export enum EnumOAuthAuthorizationStatus {
  Pending = 'pending',
  Connected = 'connected',
  Failed = 'failed',
  Expired = 'expired',
  Cancelled = 'cancelled',
}
